import { Link } from 'react-router-dom';
import type { OrderUser } from '@/api/payments';

/** Адрес карточки пользователя в разделе «Пользователи». */
const userPath = (id: string) => `/users?id=${encodeURIComponent(id)}`;

function displayName(user: OrderUser): string {
  const fullName = [user.firstName, user.lastName].filter(Boolean).join(' ');
  return fullName || user.username || 'Без имени';
}

/** Имя и контакт пользователя со ссылкой на его карточку. */
export function UserLink({ user }: { user?: OrderUser | null }) {
  if (!user) return <span className="text-text-2">—</span>;
  const contact = user.phone || user.email;
  return (
    <div className="flex min-w-0 flex-col gap-0.5">
      <Link
        to={userPath(user.id)}
        onClick={(e) => e.stopPropagation()}
        className="truncate rounded-sm font-semibold text-text outline-none hover:underline focus-visible:ring-2 focus-visible:ring-ring"
      >
        {displayName(user)}
      </Link>
      {contact && <span className="truncate text-xs text-text-2 tabular-nums">{contact}</span>}
    </div>
  );
}

/** Начало ID пользователя со ссылкой на карточку, когда API отдаёт только ID. */
export function UserIdLink({ id }: { id: string }) {
  return (
    <Link
      to={userPath(id)}
      title={id}
      onClick={(e) => e.stopPropagation()}
      className="rounded-sm font-mono text-xs text-accent-text outline-none hover:underline focus-visible:ring-2 focus-visible:ring-ring"
    >
      {id.slice(0, 8)}…
    </Link>
  );
}
